import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import session from "../../../services/session";

const AdminApiService = new AdminApi()
export default {

    data() {
        return {
            id: 0,
            model: {
                day: 'MONDAY',
                maxTrainings: 0,
                startAt: '',
                trainingType: ""
            },
            types: []
        }
    },
    methods: {
        load: load,
        editTerm: editTerm,
        getTrainingTypes: getTrainingTypes
    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        this.id = this.$route.query.id
        this.load(this.$route.query.id)
        this.getTrainingTypes()
    }
}

function load(id) {
    let _self = this;
    AdminApiService.getTermsById(id)
        .then((response) => {
            _self.model = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function editTerm() {
    let _self = this;
    AdminApiService.updateTerm(_self.model,_self.id)
        .then((response) => {
            swal('Uspešno', 'Uspešno izmenjen termin', 'success')
            this.$router.push('/pre-terms');

        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Term/Edit/EditTerm.js